import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ComunesService {

  constructor(private http:HttpClient) { }

  listarRegiones():Observable<any>{
    return this.http.get(`${environment.API_DOMAINS.servicios}/regiones/listarRegiones`);
  }

  listarComunas():Observable<any>{
    return this.http.get(`${environment.API_DOMAINS.servicios}/comunas/listarComunas`);
  }

  listarComunasRegion(regiId:number):Observable<any>{
    return this.http.get(`${environment.API_DOMAINS.servicios}/comunas/listarComunasByRegion/${regiId}`);
  }
}
